import axios from "axios";

export const getChatHistoryApi = async (sessionId, signal) => {
  // get request to the server to retrieve the ChatConversation document with the provided sessionId
  // sessionId (String): the id of the requested chat conversation
  // signal (AbortSignal): the AbortSignal used to cancel the API request if needed
  try {
    const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/chats/histories/${sessionId}`, {
      signal,
    });
    return data;
  } catch (error) {
    //status code not in 200s
    // if (!(error.name === "AbortError" || error.name === "CanceledError")) {
    //   // console.log("error loading chat history")
    // }
  }
};

export const getAdminActiveChatRoomsApi = async (adminId, signal) => {
  // get request to the server to get all active chat conversations the admin with the provided adminId currently has 
  // adminId (String): the id of the admin whose conversation are to be retrieved
    // signal (AbortSignal): the AbortSignal used to cancel the API request if needed
  try {
    const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/chats/histories/admin/${adminId}`, {
      signal,
    });
    return data;
  } catch (error) {
    //status code not in 200s
    if (!(error.name === "AbortError" || error.name === "CanceledError")) {
      // custom error message from back end
      const newErr = new Error(error.response?.data?.message);
      newErr.status = error.response?.request?.status;
      throw newErr;
    }
  }
};
